import React from "react";
import InfoCard from "../../../components/ui/InfoCard";
import FileChip from "../../../components/ui/FileChip";

const CompanyVerification = ({ company }) => {
  const { registrationNumber, vatNumber, email, companyAnnualRevenue, address, digitalAssets } =
    company || {};

  const document = (file) => <FileChip file={file} />;

  return (
    <InfoCard
      title="Company Verification"
      items={[
        ["Registration Number", registrationNumber],
        ["Registration Certificate", document(digitalAssets?.REGISTRATION_CERTIFICATE?.[0])],
        ["VAT/GST Registration", vatNumber],
        ["Address", address?.addressLine1],
        [
          "Public Liability / Public Indemnity",
          document(digitalAssets?.PUBLIC_LIABILITY_INSURANCE?.[0]),
        ],
        ["Worker Compensation", document(digitalAssets?.WORKER_COMPENSATION_INSURANCE?.[0])],
        ["State", address?.state],
        ["Country", address?.country],
        ["Zip Code", address?.zipCode],
        ["Email", email],
        ["Annual Revenue", companyAnnualRevenue],
      ]}
    />
  );
};

export default CompanyVerification;
